// write a component name ProductCard that renders a div element with the class name "product-card" and the text "Product Card"
// export the component as default

import { Checkbox, Drawer, Popconfirm, message, Modal } from "antd";
import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import {
  activityQuickAddCartUrl,
  cartItemDeleteUrl,
  orderConfirmUrl,
  USER_TYPE,
  ACTIVITY_NO_PERMISSION_STATUS_VALUE,
  getActivityNoPermissionStatusLabel,
} from "Utils/constant";
import { getAuthToken, formatPrice, getSkuCount } from "Utils/common";
import { AppContext } from "../../store";
import MHeader from "Components/mobile/common/MHeader";
import MFooter from "Components/mobile/common/MFooter";
import locationSvg from "Images/mobile/location.svg";
import pencil from "Images/mobile/pencil.svg";
import { getSelectedSTObj, getSTAddress } from "Utils/addressUtils";
import binIcon from "Images/mobile/bin.svg";
import {
  getAllCartItemIds,
  hasNonOrderableCartItems,
  addToCartErrorHandle,
  submitOrderErrorHandle,
  getBundleCartItemIds,
} from "Utils/activityHelper";
import MCartSection from "Components/mobile/cart/MCartSection";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import SwitchShipToPage from "Components/common/SwitchShipToPage";
import NewAddressForm from "Components/common/NewAddressForm";
import { getShoppingSkus, logOperation } from "Utils/operationLogUtils";
import { addToCartDataPush, pageDetailsDataPush } from "Utils/analyticsUtils";
import { UpOutlined } from "@ant-design/icons";
import MBundleSection from "Components/mobile/cart/MBundleSection";
import PromotionRules from "Components/common/PromotionRules";
import { getTieredRule } from "Utils/apiUtils";
import { encrypt } from "Utils/crypto";
import { checkOutEvent, deleteCartItemsEvent } from "Utils/aaUtils";

const MCart: React.FC<any> = (props: any) => {
  const [loadingCart, setLoadingCart] = useState<boolean>(false);
  const [quickInput, setQuickInput] = useState<string>("");
  const {
    loginState,
    cartData,
    refreshCartData,
    checkedCartItems,
    setCheckedCartItems,
    setCartCount,
    activityPermissionMeta,
  } = useContext(AppContext);
  const [allChecked, setAllChecked] = useState<boolean>(true);
  const [delConfirmOpen, setDelConfirmOpen] = useState<boolean>(false);
  const { activityId } = useParams<{ activityId: string }>();
  const [STAddressSelector, setSTAddressSelector] = useState<boolean>(false);
  const [newAddressModal, setNewAddressModal] = useState<boolean>(false);
  const [discountedDetailDrawer, setDiscountedDetailDrawer] =
    useState<boolean>(false);
  const [activityDetail] = useState<any>(
    JSON.parse(localStorage.getItem("activityDetail") || "{}")
  );
  const activityNoPermissionLabel = getActivityNoPermissionStatusLabel(
    activityPermissionMeta.activityId === activityId
      ? activityPermissionMeta.customerDataType
      : undefined
  );
  const [rulesDrawerVisible, setRulesDrawerVisible] = useState<boolean>(false);
  const [tieredRule, setTieredRule] = useState<any>(null);
  const [closedCartTip, setClosedCartTip] = useState<boolean>(false)
  const isEmployee = loginState?.userType === USER_TYPE.EMPLOYEE;
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const aaPageDetail = {
      type: "campaigns",
      name: "campaigns:myCart",
    };
    (window as any).currentCampaignId = activityId;
    pageDetailsDataPush(aaPageDetail);
  }, []);
  useEffect(() => {
    const ids = getAllCartItemIds(cartData, activityDetail.activityBasicType);
    if (ids.length === checkedCartItems.size) {
      console.log("checkedCartItems", "all checked");
      setAllChecked(true);
    } else {
      console.log("checkedCartItems", "not all checked");
      setAllChecked(false);
    }
  }, [cartData, checkedCartItems]);

  useEffect(() => {
    if (STAddressSelector || newAddressModal || rulesDrawerVisible) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
      window.scrollTo(0, document.body.scrollTop + 1);
    }
  }, [STAddressSelector, newAddressModal, rulesDrawerVisible]);
  // get activityDetail
  const handleCheckAll = (e: any) => {
    console.log("checkbox changed");
    const checked = e.target.checked;
    if (checked) {
      setAllChecked(true);

      const ids = getAllCartItemIds(cartData, activityDetail.activityBasicType);
      console.log("ids", ids);
      setCheckedCartItems(new Set(ids));
    } else {
      setAllChecked(false);
      setCheckedCartItems(new Set());
    }
    refreshCartData();
  };
  const handleDeleteCartItems = () => {
    console.log("delete cart items", checkedCartItems);
    setLoadingCart(true);
    axios(cartItemDeleteUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: getAuthToken(),
      },
      data: {
        activityId: activityId,
        ids: Array.from(checkedCartItems),
      },
    }).then((res) => {
      const respData = res.data;
      console.log("delete cart items", respData);
      if (respData.status === "success") {
        console.log("cart items deleted");
        setCheckedCartItems(new Set());
        refreshCartData();
        setCartCount(respData.data);
        deleteCartItemsEvent(activityId, Array.from(checkedCartItems), cartData);
      } else {
        message.error("删除失败");
      }
      setLoadingCart(false);
    });
  };
  const handleDelOpenChange = (newOpen: boolean) => {
    if (!newOpen) {
      setDelConfirmOpen(newOpen);
      return;
    }
    if (checkedCartItems.size === 0) {
      return;
    } else {
      setDelConfirmOpen(newOpen);
    }
  };
  const quickAddCartHandle = async () => {
    if (!quickInput || !quickInput.trim()) {
      message.warning("sku不能为空");
      return;
    }
    setLoadingCart(true);
    try {
      const reqBody = {
        activityId,
        type: "activity",
        sku: quickInput.trim(),
        quantity: 1,
        customerStNumber: getSelectedSTObj(loginState)?.accountNumber,
      };
      const resp = await axios(activityQuickAddCartUrl, {
        method: "POST",
        headers: {
          Authorization: getAuthToken(),
          "Content-Type": "application/json",
        },
        data: reqBody,
      });

      if (resp.status === 200) {
        const respData = resp.data;
        if (respData.status === "success") {
          setQuickInput("");
          message.success("快速加车成功");
          const ids: number[] = respData?.data?.cartIds;
          console.log("cartId", ids);
          ids && checkedCartItems.add(ids[0]);
          setCheckedCartItems(new Set(checkedCartItems));
          refreshCartData();
          setCartCount(respData?.data.cartCount);
          setLoadingCart(false);
          logOperation({
            opUser: loginState?.user?.user?.userId,
            opTarget: "Quick_Order",
            opTargetId: quickInput.trim(),
            opContent: "Quick_Order_Success",
          });
          addToCartDataPush({
            cartObj: {
              cartId: activityId
            },
            placement: "cart_add_more_sku",
            method: "add_more_sku",
            products: [{
              catalogId: reqBody.sku,
              quantity: reqBody.quantity,
            }]
          })
          return;
        } else if (respData.status === ACTIVITY_NO_PERMISSION_STATUS_VALUE) {
          message.warning(activityNoPermissionLabel);
          setLoadingCart(false);
          return;
        }
        // use switch case to handle different status above wirten in if else
        addToCartErrorHandle(respData, message, "quick", "mobile");
        logOperation({
          opUser: loginState?.user?.user?.userId,
          opTarget: "Quick_Order",
          opTargetId: quickInput.trim(),
          opContent: "Quick_Order_Failed",
        });
        setLoadingCart(false);
      } else {
        setLoadingCart(false);
      }
    } catch (err) {
      setLoadingCart(false);
      console.log(err);
    }
  };
  const getOrderBtnStatus = () => {
    if (checkedCartItems.size === 0) {
      return {
        disabled: true,
        message: "去结算",
        notDisplay: true,
      };
    }
    if (
      cartData.total === "0" ||
      cartData.total === "0.0" ||
      cartData.total === "0.00"
    ) {
      return {
        disabled: true,
        message: "去结算",
      };
    }
    const st = getSelectedSTObj(loginState);
    if (!st) {
      return {
        disabled: false,
        message: "未选择收货地址",
      };
    }
    if (!cartData.matchStatus) {
      return {
        disabled: false,
        confirm: true,
        message: "未满足规则，继续下单？",
      };
    }
    return {
      disabled: false,
      message: "去结算",
    };
  };
  const gotoOrderConfirm = () => {
    if (loadingCart) return;
    if (checkedCartItems.size === 0) {
      message.warning("请选择商品");
      return;
    }
    let shoppingItems: number[] = [],
      result = false;
    if (activityDetail.activityBasicType === "bundle_promotion") {
      shoppingItems = getBundleCartItemIds(
        Array.from(checkedCartItems),
        cartData
      );
    } else {
      shoppingItems = Array.from(checkedCartItems);
      result = hasNonOrderableCartItems(shoppingItems, cartData);
    }
    if (result) {
      message.warning("存在不可下单商品");
      return;
    }
    // if not, call confirm api
    const selectedST = getSelectedSTObj(loginState);
    if (!selectedST) {
      setNewAddressModal(true);
      return;
    }
    // check cartData is matchRule
    if (!cartData?.matchStatus) {
      let msg =
        "您当前未满足活动规则，您可继续提交订单，此订单将会以您的协议价或飞享价进行结算，即无法参与当前活动。";
      if (cartData.allowSingleItem) {
        msg =
          "您当前未满足所有活动规则，但您可继续提交订单，此订单产品将按照您已符合的规则计算价格进行结算。";
      }
      Modal.confirm({
        className: "confirmModal",
        title: "未满足规则，继续下单？",
        content: msg,
        okText: "确认",
        cancelText: "取消",
        onOk() {
          submitOrder(selectedST, shoppingItems, { matchStatus: false });
        },
        onCancel() {
          console.log("Cancel");
        },
      });
      return;
    }
    if (cartData.matchStatus && cartData.exceedOrderLimit) {
      Modal.confirm({
        className: "confirmModal",
        title: "注意！您已超过此活动的购买次数上限，继续下单？",
        content: (
          <div>
            <p>
              您当前已超过此活动的购买次数上限，此订单将无法享受本次活动优惠
            </p>
            <p>
              您可以继续提交订单，系统将以产品的其他优惠价为您结算，请至订单详情页确认价格明细
            </p>
          </div>
        ),
        okText: "确认",
        cancelText: "取消",
        style: { top: "32vh", width: "90%" },
        onOk() {
          submitOrder(selectedST, shoppingItems, { matchStatus: false });
        },
        onCancel() {
          console.log("Cancel");
        },
      });
      return;
    }

    submitOrder(selectedST, shoppingItems, { matchStatus: true });
  };
  const submitOrder = async (
    selectedST: any,
    shoppingItems: any,
    options: { matchStatus: boolean }
  ) => {
    const reqBody = {
      shipTo: selectedST?.accountNumber,
      activityId: activityId,
      cartIds: shoppingItems,
      tieredRuleId: cartData?.currentTieredRule?.id
    };
    setLoadingCart(true);
    axios(orderConfirmUrl, {
      method: "POST",
      headers: {
        Authorization: getAuthToken(),
        "Content-Type": "application/json",
      },
      data: reqBody,
    })
      .then((resp) => {
        console.log("resp", resp);
        if (resp.status === 200) {
          const respData = resp.data;
          if (respData?.status === "success") {
            respData.data.activityId = activityId;
            // localStorage.setItem(
            //   `${activityId}OrderPreviewData`,
            //   JSON.stringify({
            //     reqBody,
            //     respData: respData.data,
            //   })
            // );
            encrypt(JSON.stringify({
              reqBody,
              respData: respData.data,
            })).then((encryptedData) => {
              localStorage.setItem(
                `${activityId}OrderPreviewData`,
                JSON.stringify(encryptedData)
              );
              const searchParams = new URLSearchParams(location.search);
              checkOutEvent(activityId, shoppingItems, cartData);
              navigate(
                `/m/orderPreview/${activityId}?${searchParams.toString()}`
              );
            })
            return;
          }
          if (respData?.status === ACTIVITY_NO_PERMISSION_STATUS_VALUE) {
            message.warning(activityNoPermissionLabel);
            setLoadingCart(false);
            return;
          }
          submitOrderErrorHandle(respData, message);
          setLoadingCart(false);
        } else {
          message.error("操作失败，请联系在线客服");
          setLoadingCart(false);
        }
      })
      .catch((err) => {
        message.error("操作失败，请联系在线客服");
        setLoadingCart(false);
      });
    const skus = getShoppingSkus(shoppingItems, cartData);
    if (options.matchStatus) {
      logOperation({
        opUser: loginState?.user?.user?.userId,
        opTarget: "Submit_Order",
        opTargetId: JSON.stringify(skus),
        opContent: "MatchRule",
      });
    } else {
      logOperation({
        opUser: loginState?.user?.user?.userId,
        opTarget: "Submit_Order",
        opTargetId: JSON.stringify(skus),
        opContent: "NotMatchRule",
      });
    }
  };

  const { originalTotal, savingTotal, total } = cartData;
  const selectedST = getSelectedSTObj(loginState);
  const stAddress = getSTAddress(selectedST);
  const cartTitle = activityDetail?.activityBasicType === "bundle_promotion" ? "已选套装" : "已选产品";
  const originalPromoTotal = (cartData?.savingDetails as any)?.originalPromoTotal;

  return (
    <>
      <MHeader title={cartTitle} />
      <div className="mobilePageBody mCartPage">
        {selectedST ? (
          <div className="shipAddressCard">
            <div className="left">
              <img src={locationSvg} alt="location"></img>
              <div className="addressWrapper">
                <div className="title">收货地址</div>
                <div className="address">{stAddress}</div>
              </div>
            </div>
            {
              !isEmployee && (
                <div
                  className="pencil"
                  onClick={() => {
                    setSTAddressSelector(true);
                  }}
                >
                  <img src={pencil} alt="change address"></img>
                </div>
              )
            }
          </div>
        ) : !isEmployee ? (
          <div className="shipAddressNew">
            <div
              className="btn-link"
              onClick={() => {
                setNewAddressModal(true);
              }}
            >
              {"新建收货地址"}
            </div>
          </div>
        ) : null}
        {activityDetail?.activityBasicType === "bundle_promotion" ? (
          <MBundleSection
            activityId={activityId}
            loadingCart={loadingCart}
            activityDetail={activityDetail}
          />
        ) : (
          <MCartSection activityId={activityId} loadingCart={loadingCart} />
        )}
        <div className="priceSumCard">
          <div className="title">价格详情</div>
          <div className="block2 priceItem firstItem borderBottom">
            <label>产品价格({getSkuCount(cartData)}件)</label>
            <span className="originTotal">{formatPrice(originalTotal)}</span>
          </div>
          <div className="priceItem borderBottom">
            <label>共节省</label>
            <span className="savingTotal">- {formatPrice(savingTotal)}</span>
          </div>
          <div className="priceItem lastItem">
            <label>总金额</label>
            <span className="total">{formatPrice(total)}</span>
          </div>
        </div>
        {activityDetail.activityBasicType === "bundle_promotion" ? null : (
          <div className="quickAddWrapper">
            <div className="quickAddInner">
              <div className="title">快速加车</div>
              <div className="searchWrapper">
                <input
                  type="text"
                  placeholder="请输入当前活动产品货号"
                  value={quickInput}
                  onChange={(e) => {
                    setQuickInput(e.target.value);
                  }}
                ></input>
                <button className="addBtn" onClick={quickAddCartHandle}>
                  添加
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      {cartData.hasFurtherPromotion && !closedCartTip ? (
        <div className="my-cart-footer-fixedTip">
          <span>凑单助手I 继续选购，享受更多优惠</span>
          <span
            className="checkBtn"
            onClick={() => {
              setRulesDrawerVisible(true);
              if (tieredRule || !activityId) return;
              getTieredRule(activityId, (data: any) => {
                setTieredRule(data);
              });
            }}
          >
            凑单详情
          </span>
        </div>
      ) : null}
      <div className="mCartFooter">
        <div className="left">
          <span className="itemWrapper">
            <Checkbox checked={allChecked} onClick={handleCheckAll}></Checkbox>
            <span className="btnText">全选</span>
          </span>
          <Popconfirm
            open={delConfirmOpen}
            title="删除购物车产品"
            description="确认要删除吗?"
            onConfirm={handleDeleteCartItems}
            onOpenChange={handleDelOpenChange}
            okText="确认"
            cancelText="取消"
          >
            <span className="itemWrapper">
              <img className="binIcon" alt="delete" src={binIcon}></img>
              <span className="btnText">删除</span>
            </span>
          </Popconfirm>
        </div>
        {getOrderBtnStatus().notDisplay ? null : (
          <div
            className="right"
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <div style={{ textAlign: "right" }}>
              <span className="total">{formatPrice(cartData.total)}</span>
              {cartData.matchStatus ? (
                <div
                  style={{
                    textAlign: "right",
                    color: "#e71316",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    console.log("open drawer");
                    setDiscountedDetailDrawer(true);
                  }}
                >
                  {" "}
                  <span style={{ fontSize: "12px", paddingRight: "4px" }}>
                    共减 {formatPrice(savingTotal)}
                  </span>
                  <span style={{ padding: "0 4px", fontSize: "12px" }}>
                    查看明细<UpOutlined></UpOutlined>
                  </span>
                </div>
              ) : null}
            </div>
            <button
              disabled={getOrderBtnStatus().disabled}
              className="btn-confirm"
              onClick={gotoOrderConfirm}
            >
              {getOrderBtnStatus().message}
            </button>
          </div>
        )}
      </div>
      <MFooter activityId={activityId} navItem2={"activity"}></MFooter>
      <NewAddressForm
        open={newAddressModal}
        setNewAddressModal={setNewAddressModal}
      ></NewAddressForm>
      <Drawer
        open={STAddressSelector}
        onClose={() => {
          setSTAddressSelector(false);
        }}
      >
        <SwitchShipToPage
          page="Shopping_Cart"
          showSwitchStPage={STAddressSelector}
          setShowSwitchStPage={setSTAddressSelector}
        ></SwitchShipToPage>
      </Drawer>
      <Drawer
        open={discountedDetailDrawer}
        onClose={() => setDiscountedDetailDrawer(false)}
        placement="bottom"
        className="mdiscountedDetailDrawer"
      >
        <div>
          <h3
            style={{
              textAlign: "center",
              margin: 0,
              padding: 0,
              fontSize: "18px",
            }}
          >
            金额明细
          </h3>
          <p
            style={{
              textAlign: "center",
              margin: 0,
              paddingTop: "5px",
              color: "#70707a",
            }}
          >
            实际优惠金额以下单页为准
          </p>
        </div>
        <div className="priceDetailWrapper">
          <div className="line">
            <label className="bold-property">目录价</label>
            <span>
              {" "}
              <label className="bold-property">
                {checkedCartItems.size > 0
                  ? formatPrice(cartData?.savingDetails?.originalTotal)
                  : "¥ 0.00"}{" "}
              </label>
            </span>
          </div>
          {cartData?.savingDetails?.singleSaving &&
            cartData?.savingDetails?.singleSaving !== "0" &&
            cartData?.savingDetails?.singleSaving !== "0.00" && (
              <div className="line">
                <label className="sub-item">单品优惠</label>
                <span
                  style={{
                    color: "#e71316",
                  }}
                >
                  减 {formatPrice(cartData?.savingDetails?.singleSaving)}
                </span>
              </div>
            )}

          {
                originalPromoTotal &&
                originalPromoTotal !== "0" &&
                originalPromoTotal !== "0.00" && (
                  <div className="line">
                    <label className="bold-property">商品总价</label>
                    <span>
                      {" "}
                      {
                        originalPromoTotal && (
                          <label className="bold-property">
                            {checkedCartItems.size > 0
                              ? formatPrice(originalPromoTotal)
                              : "¥ 0"}{" "}
                          </label>
                        )
                      }
                    </span>
                  </div>
                )
          }
          {cartData?.savingDetails?.combinationSaving &&
            cartData?.savingDetails?.combinationSaving !== "0" &&
            cartData?.savingDetails?.combinationSaving !== "0.00" && (
              <div className="line">
                <label className="sub-item">组合优惠</label>
                <span
                  style={{
                    color: "#e71316",
                  }}
                >
                  <span style={{ paddingRight: "4px" }}>
                    {cartData?.savingDetails?.singleSaving &&
                    cartData?.savingDetails?.singleSaving !== "0" &&
                    cartData?.savingDetails?.singleSaving !== "0.00"
                      ? "再减"
                      : "减"}
                  </span>
                  <span>
                    {formatPrice(cartData?.savingDetails?.combinationSaving)}
                  </span>
                </span>
              </div>
            )}

          <hr className="hr-wrapper"/>
          <div className="total-wrapper">
            
            {
                cartData?.savingTotal &&
                cartData?.savingTotal !== "0" &&
                cartData?.savingTotal !== "0.00" ? (
                  <div
                    className="line total-saving"
                  >
                    <label className="bold-property flag-label">共减</label>
                    <span
                      style={{
                        color: "#e71316",
                        fontWeight: "bold",
                      fontSize: "15px",
                      }}
                    >
                      {formatPrice(cartData?.savingTotal)}
                    </span>
                  </div>
                ) : 
                  <div
                    className="line total-saving"
                  >
                  </div>
            }
            <div
              className="line"
              style={{
                lineHeight: "42px",
                fontSize: "16px",
                fontWeight: "bold",
              }}
            >
              <label>合计</label>
              <span>{formatPrice(cartData?.savingDetails?.total)}</span>
            </div>
          </div>
        </div>
      </Drawer>
      <Drawer
      height={"68vh"}
      open={rulesDrawerVisible}
      placement="bottom"
      className="mdiscountedDetailDrawer"
      onClose={() => {
        setRulesDrawerVisible(false)
      }}
      >
        <PromotionRules
          activityId={activityId}
          tieredRule={tieredRule}
          currentTieredRule={cartData?.currentTieredRule}
          matchStatus={cartData?.matchStatus}
          allowLinearTier={cartData?.allowLinearTier}
          activityDetail={activityDetail}
        />
      </Drawer>
    </>
  );
};

export default MCart;
